<section #gallery *ngIf="galleryOpen" class="popup-overlayVC">
    <div class="popupVC">
        <div class="popupVC__content">
            <swiper *ngIf="images" #usefulSwiperVC [config]="config" style="width: 100%; top: 20%;">
                <div class="swiper-wrapper">
                  <img class="swiper-slide" *ngFor="let image of images, let i = index" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat',
                                  'background-size': 'contain',
                                  'display': 'inline-block',
                                  'width': '100%',
                                  'background-color': 'rgba(0,0,0,.8)',
                                  'position': 'relative',
                                  'transition': 'transform 0.1s linear 0s',
                                  'height': '500px'}" />
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
                <!-- Add Arrows -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </swiper>
              <button class="exitGalBtn" (click)="galleryOpen = false;">Exit Gallery</button>
        </div>
    </div>
</section>
<div id="headerSorting" class="row header-single">
    <div class="hotel-title-info">
        <h1 *ngIf="hotel">
            <span>{{hotel.name}} </span>
            <span class="address">{{hotel.cityOnWebsite}}</span>
        </h1>
    </div>
    <div class="col-md-2 single-hotel-back">
        <div class="backBtn">
            <a (click)= "goBack()">Back to villas collection</a>
        </div>
    </div>
</div>

<div id="singleHotel" class="hotelSingleWrapper ">
    <div id="" class="row" style="padding-top:0px;margin:0;">
        <section *ngIf="!galleryOpen" class="col-md-12" style="padding:0;">
            <ngb-carousel #carousel (click)="openGallery()" [interval]= "false" *ngIf="images" (slide)="onSlide($event)" id="villa-carousel">
                <ng-template ngbSlide *ngFor="let image of images; let i = index" [id]="i">
                    <div [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                        'display': 'inline-block',
                        'width': '100%',
                        'height': '67vh',
                        'background-color': 'rgba(0,0,0,.8)',
                        'position': 'relative',
                        'transition': 'transform 0.1s linear 0s'}">
                    </div>
                </ng-template>
            </ngb-carousel>
        </section>
        <div class="horizontal-seperator"></div>
        <div class="main-wrap">
            <div *ngIf="experiences" class="row experiences-wrapper">
                <div class="col-md-12 experiences-heading">
                    <h2>Vervendo Experiences <span *ngIf="hotel">provided by {{hotel.name}}</span></h2>
                </div>
                <div class="experienceItemWrap" *ngFor = "let ex of experiences;let i=index" [ngClass]="(i%3 === 0)?'col-md-4': 'col-md-4'">
                    <div class="experienceItem" [ngClass]="isExperienceDescriptionVisible(i)?'':'expandHeight'">
                        <div class="experience-title">{{ex.title}}</div>
                        <img class="experience-image" *ngIf="!showImage[i]" [src]="'https://' + environment.adminUrl +'/webresources/frontend/entity.hoteloptionalextra/image/thumbnail/' + ex.id" (error)="test($event,i)">
                        <p class="experience-text" *ngIf="ex.description.length>120">{{ex.description | slice:0:120}}<span *ngIf="!isExperienceDescriptionVisible(i)" [ngClass]="isExperienceDescriptionVisible(i)?'hidden-dots':'dots'">...</span><span [ngClass]="isExperienceDescriptionVisible(i)?'more':'hidden'" *ngIf="isExperienceDescriptionVisible(i)">{{ex.description | slice:120:end}}</span></p>
                        <p class="experience-text" *ngIf="ex.description.length<=120">{{ex.description}}</p>
                        <button class="experience-more" *ngIf="ex.description.length>120" (click)="readMore(i)">Show {{!isExperienceDescriptionVisible(i)? 'more': 'less'}}</button>
                    </div>
                </div>
                <div class="col-md-12" style="padding-bottom: 50px;">
                    <button *ngIf="isMoreExperiencesAvailable()" class="load-more-experiences" (click)="loadMoreExperiences()">Load More Experiences</button>
                    <button *ngIf="!isMoreExperiencesAvailable() && allExperiences.length>5" class="load-more-experiences" (click)="loadLessExperiences()">Load Less Experiences</button>
                </div>
            </div>
            <div class="row vc-about">
                <div class="col-md-12 vc-heading-wrap">
                    <h2 *ngIf="hotel" class="vc-heading">About {{hotel.name}}</h2>
                </div>
                <div class="col-md-12 vc-body">
                    <main class="singleTabs">
                        <p *ngIf="hotel" [innerHTML]="hotel.description"></p>
                        <div class="hotelFacilitiesWrapper" *ngIf="facilities">
                            <div class="hotelFacilityRow row">
                                <div class="col-md-12 facilities-heading">
                                    <h3>Facilities</h3>
                                </div>
                                <div *ngIf="facilities.general && facilities.general.length > 0" class="facilities-category col-3">
                                    <h3>General</h3>
                                    <div *ngFor="let facility of facilities.general">{{facility}}</div>
                                </div>
                                <div *ngIf="facilities.activities && facilities.activities.length > 0" class="facilities-category col-5">
                                    <h3>Activities</h3>
                                    <div *ngFor="let activity of facilities.activities">{{activity}}</div>
                                </div>
                                <div *ngIf="facilities.services && facilities.services.length > 0" class="facilities-category col-3">
                                    <h3>Services</h3>
                                    <div *ngFor="let service of facilities.services">{{service}}</div>
                                </div>
                            </div>
                        </div>
                            <!--<app-hotel-single-inner *ngIf="tabHeaderInfo" [roomOffers]="roomOffers" [nights]="tabHeaderInfo.numberOfNights" [cards]="offerInfo.creditCards"
                                (optionsChanged)="selectMeal($event)">
                            </app-hotel-single-inner>

                            <app-hotel-single-facilities [facilities]="facilitiesTab"></app-hotel-single-facilities>

                            <app-hotel-single-description [hotelDscription]="hotelDscription"></app-hotel-single-description>

                            <app-hotel-single-location [locations]="locations"></app-hotel-single-location>-->

                    </main>
                </div>
            </div>
        </div>
    </div>
</div>
